export default __webpack_public_path__ + "static/media/LEDflood.6c0dc23d.png";